
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 96 96"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#767676"}},[_c('path',{attrs:{"d":"M19.164 0c6.311 0 11.427 5.012 11.427 11.195 0 6.183-5.116 11.195-11.427 11.195S7.736 17.378 7.736 11.195C7.736 5.012 12.853 0 19.164 0zM76.836 0c6.311 0 11.427 5.012 11.427 11.195 0 6.183-5.116 11.195-11.427 11.195s-11.427-5.012-11.427-11.195C65.409 5.012 70.525 0 76.836 0zM40.055 11.502h.005c-.004-.103-.016-.203-.016-.307 0-4.215 3.497-7.632 7.811-7.632s7.811 3.417 7.811 7.632l.376 7.824c2.02-2.018 3.27-4.777 3.27-7.824C59.312 5.012 54.183 0 47.856 0S36.4 5.012 36.4 11.195c0 3.075 1.27 5.859 3.324 7.883l.331-7.576z","fill-rule":"evenodd","clip-rule":"evenodd"}}),_c('path',{attrs:{"d":"M41.419 45.441l-18.667 7.808a10.166 10.166 0 00-6.198 10.43l5.553 26.241a6.922 6.922 0 006.574 5.48l20.367.597a9.642 9.642 0 008.638-4.878l19.082-33.66a4.233 4.233 0 00-1.512-5.721 4.255 4.255 0 00-5.213.661l-9.184 9.303c-2.282 2.311-6.227.785-6.352-2.456l-1.852-48.151a4.751 4.751 0 00-4.752-4.563 4.751 4.751 0 00-4.75 4.507l-1.734 34.402z"}})])])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/home/choose.svg